import routes from "./renewalRoutes";
import links from "./links";
import store from "./renewalStore";

export default {
  install(Vue, options) {
    options.router.addRoute(...routes);
    options.store.registerModule("Renewal", store);
    options.store.commit("Dashboard/SET_LINKS", links);
  },
};
